import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { baseUrl } from '../config/config';
import Modal from './Modal';
import "react-lazy-load-image-component/src/effects/blur.css";
import "lightbox2/dist/js/lightbox-plus-jquery";
import "lightbox2/dist/css/lightbox.css";

function Gallery({ data, selectedYear, selectedTech, selectedSeries }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modaltech, setModaltech] = useState('');
    const [modalDesc, setModalDesc] = useState('');
    const [modalFDesc, setModalFDesc] = useState('');

    const openModal = (src, title, tech, desc, fulldesc) => {
        setModalImage(src);
        setModalTitle(title);
        setModaltech(tech);
        setModalDesc(desc);
        setModalFDesc(fulldesc);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImage('');
        setModalTitle('');
        setModaltech('');
        setModalDesc('');
        setModalFDesc('');
    };
    const filteredData = data.filter(item => {
        if (selectedYear && selectedYear !== 'all' && item.year !== selectedYear) {
            return false;
        }

        if (selectedTech && selectedTech !== 'Все' && !item.tech.split(',').map(tech => tech.trim()).includes(selectedTech)) {
            return false;
        }

        if (selectedSeries && selectedSeries !== 'all' && item.series_id !== selectedSeries) {
            return false;
        }

        return true;
    });

    return (
        <div className="allbox">
            {filteredData.map(item => (
                <div className="img-box" key={item.ID} data-years={item.year} data-tech={item.tech} data-series={item.series_id} data-img="all">
            {item.selling === '0' && (
                <div className={item.sold === '0' ? 'free' : item.sold === '1' ? 'sold' : 'reserved'}>
                    {item.sold === '0' ? 'Sale' : item.sold === '1' ? 'Fold' : 'Reserved'}
                </div>
            )}
                    <a 
                        href={`${baseUrl}${item.src}`} 
                        data-lightbox={`${selectedYear || 'all'}-${selectedTech || 'all'}`} 
                        className='image-link' 
                        title={`${item.title ? item.title : item.name} - ${item.tech} - ${item.desc} - art-${item.ID}`}
                    >
                        <div className="name-box">
                            {item.title ? item.title : item.name}
                            <span>
                                {item.tech}
                                <br></br>
                                {item.year}
                            </span>
                        </div>
                        <LazyLoadImage
                            src={`${baseUrl}pics/${item.year}/thumbs/thumb_${item.name}`}
                            alt={item.name}
                            effect="blur"
                            visibleByDefault={false}
                            delayTime={300}
                            className='landscape'
                        />
                    </a>
                    {item.fulldesc && (
                        <div 
                            className="modal-box"
                            onClick={() => openModal(
                                `${baseUrl}${item.src}`,
                                `${item.title ? item.title : item.name}`,
                                `${item.tech}, ${item.year} год`,
                                `${item.desc}`, `${item.fulldesc}`
                            )}
                            >
                            Подробнее
                        </div>
                    )}
                </div>
            ))}
            <Modal 
                src={modalImage} 
                title={modalTitle} 
                tech={modaltech}
                desc={modalDesc}
                fulldesc={modalFDesc}
                isOpen={isModalOpen} 
                onClose={closeModal} 
            />
        </div>
    );
}

export default Gallery;
